import { LinearLoader } from "../../../../components/linear-loader/LinearLoader";
import { useEffect } from "react";
import { getMarketplaceSaleStats } from "../../../../api";
import { useSnackbar } from "notistack";
import { useMarketplaceContext } from "../../../../context-state/MarketplaceContext";

const EMPTY_GENERAL_STATS = {
    totalSellers: 0,
    totalEvents: 0,
    totalEventOrders: 0,
    totalSumOfAllEventOrders: 0,
    totalSumOfAllEventOrdersRefunds: 0,
    totalProfit: 0,
    totalMoneyToSendSellers: 0,
    totalAdvancePaidToSellers: 0,
    totalLeftToPaySellers: 0,
};

export const MarketSaleStatsGuard = ({ children }) => {

    const { enqueueSnackbar } = useSnackbar();
    const {
        marketplaceSaleStats, setMarketPlaceSaleStats, setMarketPlaceGeneraleSaleStats,
        marketplace, saleStatsRange, setSaleStatsLoading,
    } = useMarketplaceContext();

    useEffect(() => {
        // Wait until the marketplace is available (it's set during auth init).
        // Guards against a mount before context populates, and refetches if it
        // ever changes — keyed on marketplace._id in the deps below.
        if (!marketplace?._id) return undefined;
        let cancelled = false;
        const fetchStats = async () => {
            setSaleStatsLoading(true);
            try {
                const { data } = await getMarketplaceSaleStats({
                    marketplaceId: marketplace._id,
                    from: saleStatsRange.from,
                    to: saleStatsRange.to,
                    dateMode: saleStatsRange.dateMode,
                });
                if (cancelled) return;
                setMarketPlaceSaleStats(data.res);
                setMarketPlaceGeneraleSaleStats(data.generalStats);
            } catch (e) {
                if (cancelled) return;
                console.log(e);
                enqueueSnackbar(e.userFacingMessage || e.response?.data?.message || e.message, { variant: 'error' });
                setMarketPlaceSaleStats([]);
                setMarketPlaceGeneraleSaleStats(EMPTY_GENERAL_STATS);
            } finally {
                if (!cancelled) setSaleStatsLoading(false);
            }
        };
        fetchStats();
        return () => { cancelled = true; };
    }, [saleStatsRange, marketplace?._id]);

    // First load only: nothing to show yet. Subsequent date-range changes keep the
    // page mounted and swap the data regions for skeletons (see MarketGeneralStats
    // and the sale-stats table), so the filters stay interactive during refetch.
    if (marketplaceSaleStats == null) return <LinearLoader />;

    return children;
};
